export default __webpack_public_path__ + "static/media/photo2-lqMAX.b6a2f640.jpg";